module.exports = __webpack_public_path__ + "img/awind.380fff4b.png";